import React, { useState } from 'react';
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './EssDashboard.css';

export function HolidayCard({ holidays }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => setCurrentIndex((prev) => (prev + 1) % holidays.length);
  const prev = () =>
    setCurrentIndex((prev) => (prev - 1 + holidays.length) % holidays.length);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { month: 'long', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  };

  const hasHolidays = holidays && holidays.length > 0;

  return (
    <div className="card shadow-sm h-100 border-0 bgColor1" style={{ backgroundColor: "#ccf1cc6b" }}>
      <div className="card-header bg-transparent border-0 pb-2 d-flex align-items-center gap-2">
        <FaCalendarAlt className="text-success mx-1" />
        <h5 className="mb-0 text-success fw-semibold">Holidays</h5>
      </div>
      <div className="card-body d-flex flex-column gap-4">
        {hasHolidays ? (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <button className="btn btn-sm btn-light" onClick={prev}>
                <FaChevronLeft className="text-success" />
              </button>

              <div className="mx-4 flex-fill text-center">
                <div className="bg-white rounded p-3 shadow-sm">
                  <div className="d-flex justify-content-center align-items-center gap-2 mb-2">
                    <div className="bg-success text-white rounded px-3 py-2 medium fw-large">
                      {new Date(holidays[currentIndex].start_date).toLocaleString('default', { month: 'long' })}
                    </div>
                    <div className="fs-1 fw-bold text-success mx-1">
                      {new Date(holidays[currentIndex].start_date).getDate()}
                    </div>
                  </div>
                  <h6 className="fw-semibold mb-1">{holidays[currentIndex].holiday_name}</h6>
                  <p className="fw-bold text-muted small mb-0">
                    {formatDate(holidays[currentIndex].start_date)}
                  </p>
                </div>
              </div>

              <button className="btn btn-sm btn-light" onClick={next}>
                <FaChevronRight className="text-success" />
              </button>
            </div>

            <div className="d-flex justify-content-center gap-3 mt-3">
              {holidays.map((_, index) => (
                <div
                  key={index}
                  className="rounded-circle mx-1"
                  style={{
                    width: '14px',
                    height: '14px',
                    backgroundColor: index === currentIndex ? '#28a745' : 'rgba(40,167,69,0.3)',
                  }}
                ></div>
              ))}
            </div>
          </>
        ) : (
          <div className="text-center p-4">
            <h6 className="text-muted fw-semibold mb-1">No holiday available</h6>
            <p className="small text-muted mb-0">Check back later for updates.</p>
          </div>
        )}
      </div>
    </div>
  );
}

